<template>
  <line-chart
    title="Sessions vs Objectif"
    :loading="loading"
    :colors="colors"
    :series="series"
    :yAxis="yAxis"
    :xAxis="xAxis"
    :dags="['ga_get_and_store_site_daily_dag']"
  ></line-chart>
</template>

<script>
import { cacheTime } from "@axios";
import moment from "moment/moment";

import { colors } from "@/utils/constants";
import { getDate, getDaysArray, monthRange } from "@/utils/dates";
import { formatNumber } from "@/utils/formatting";
import LineChart from "@/components/common/charts/LineChart";

import useAxios from "@/hooks/useAxios";

export default {
  name: "SessionsObjectivesChart",
  components: {
    LineChart,
  },
  data() {
    return {
      loading: false,
      series: [
        {
          name: "Sessions",
          data: [],
        },
        {
          name: "Objectif",
          data: [],
        },
      ],
      colors: [colors.sessions, colors.objective], // "#2da0ed", "#00d4bd", "#9C27B0",
      yAxis: [
        {
          min: 0,
          forceNiceScale: true,
          labels: {
            formatter: (val) => formatNumber(val),
          },
        },
      ],
      xAxis: {
        categories: [],
      },
    };
  },
  setup() {
    const { axiosGet } = useAxios();

    return {
      axiosGet,
    };
  },
  methods: {
    async getData() {
      if (
        this.applyFilters &&
        !this.loading &&
        this.month &&
        this.month.length > 5
      ) {
        let queryParams = {
          month: this.month,
          ...(this.sites && this.sites.length > 0
            ? { sites: this.sites.join(",") }
            : {}),
          ...(this.partnerViews && this.partnerViews.length > 0
            ? { partner_views: this.partnerViews.join(",") }
            : {}),
        };
        const range = monthRange(this.month);
        const categories = getDaysArray(range[0], range[1]);
        const mainData = {};
        const yesterday = moment(getDate(-1));
        for (const x of categories) {
          const defaultValue = moment(new Date(x)) >= yesterday ? null : 0;
          mainData[x] = {
            ca: defaultValue,
            objRevenue: defaultValue,
            sessions: defaultValue,
            objSessions: defaultValue,
          };
        }
        /* const detailedRevenueResponse = await this.$store.dispatch(
          "/premium/getDetailedRevenue",
          queryParams
        ); */

        this.loading = true;
        const { data: detailedAudienceData } = await this.axiosGet(
          "/programmatic/detailed-audience-monthly-report",
          queryParams,
          {
            cache: {
              maxAge: cacheTime,
            },
          }
        );
        /* const totalResponse = await axios.get(
          "/programmatic/total-monthly-report",
          {
            params: queryParams,
            cache: {
              maxAge: cacheTime,
            },
          }
        );*/

        delete queryParams["partner_views"];
        queryParams["objtype"] = "sessions";
        const { data: objectivesSessionsData } = await this.axiosGet(
          "/objectives/",
          queryParams,
          {
            cache: {
              maxAge: cacheTime,
            },
          }
        );

        this.xAxis = {
          ...this.xAxis,
          categories,
        };

        detailedAudienceData.map((data) => {
          mainData[data["date"]]["sessions"] = data["sessions"];
        });

        const objectiveSessionsMonth = objectivesSessionsData["value"];
        const objectiveSessionsDay = objectiveSessionsMonth / categories.length;

        for (const x of categories) {
          mainData[x]["objSessions"] = objectiveSessionsDay;
        }

        this.series = [
          {
            name: "Sessions",
            data: categories.map((category) => mainData[category]["sessions"]),
          },
          {
            name: "Objectif",
            data: categories.map(
              (category) => mainData[category]["objSessions"]
            ),
          },
        ];

        this.loading = false;
      }

      // Force clicking on button again to re-run that request :
      // (we don't call this dispatch earlier to be sure, as state is async, that all listening components could run their requests)
      this.$store.dispatch("common/updateApplyFilters", false);
    },
  },
  computed: {
    applyFilters() {
      return this.$store.getters["common/getApplyFilters"];
    },
    sites() {
      return this.$store.getters["premium/getSites"];
    },
    month() {
      return this.$store.getters["premium/getMonthDate"];
    },
    partnerViews() {
      return this.$store.getters["premium/getPartnerViews"];
    },
  },
  watch: {
    applyFilters() {
      this.getData();
    },
  },
};
</script>
